import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';

/**
 * Whether pets and cosmetics are shown as their 2D art or their 3D models,
 * site-wide: flip it anywhere and every preview follows. Remembered in this
 * browser. Things with no 3D model yet show their art either way.
 */
const ViewModeContext = createContext({ mode: '2d', setMode: () => {} });
const KEY = 'petlings.viewMode';

export function ViewModeProvider({ children }) {
  const [mode, setModeState] = useState(() => {
    // ?view=3d in a link opens the site in that mode, and keeps it.
    const asked = new URLSearchParams(window.location.search).get('view');
    if (asked === '2d' || asked === '3d') {
      try { localStorage.setItem(KEY, asked); } catch (_) { /* this visit only */ }
      return asked;
    }
    try {
      return localStorage.getItem(KEY) === '3d' ? '3d' : '2d';
    } catch (_) {
      return '2d';
    }
  });

  const setMode = useCallback((next) => {
    setModeState(next);
    try { localStorage.setItem(KEY, next); } catch (_) { /* private mode: this visit only */ }
  }, []);

  // Another tab flipped it.
  useEffect(() => {
    const onStorage = (e) => { if (e.key === KEY) setModeState(e.newValue === '3d' ? '3d' : '2d'); };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, []);

  return <ViewModeContext.Provider value={{ mode, setMode }}>{children}</ViewModeContext.Provider>;
}

export function useViewMode() {
  return useContext(ViewModeContext);
}
